<tui-scrollbar class="scroll">
  <div class="login">
    <div class="login__form">
      <div *ngIf="enterType === EnterType.Bot" class="loading-wrapper">
        <app-logo [mode]="'header-logo'"></app-logo>

        <h2 class="loading-wrapper__title">{{ 'common.labels.loading' | translate }}...</h2>
      </div>

      <app-login-enter-by-code
        *ngIf="enterType === EnterType.Email && !openPolicy"
        [title]="appConfig?.loginScreenTitle"
        [(phoneNumber)]="phoneNumber"
        (onSuccess)="onApplyToken($event)"
        (onLoading)="onLoading($event)"
      >
        <ng-container [ngTemplateOutlet]="notificationLoginTmp"></ng-container>

        <ng-container [ngTemplateOutlet]="registrationLink"></ng-container>

        <ng-container [ngTemplateOutlet]="privacyLink"></ng-container>

        <ng-container [ngTemplateOutlet]="mobileAppLinks"></ng-container>
      </app-login-enter-by-code>

      <app-login-policy
        *ngIf="openPolicy"
        [enterType]="enterType"
        [pageName]="'login'"
        (close)="openPolicy = false"
      ></app-login-policy>

      <ng-template #registrationLink>
        <button
          *ngIf="appConfig?.allowUserRegistrationForm"
          tuiButton
          type="button"
          size="l"
          appearance="outline-blue"
          [class.disabled-link]="loading"
          [routerLink]="['/registration', appConfig?.defaultAssociationId]"
        >
          {{ 'components.login.buttons.registration' | translate }}
        </button>
      </ng-template>

      <ng-template #privacyLink>
        <app-link class="privacy" color="grey" [class.disabled-link]="loading" (click)="openPolicy = true">
          {{ 'components.login.labels.privacyPart1' | translate }}
          <u>{{ 'components.login.labels.privacyPart2' | translate }}</u>
          {{ 'components.login.labels.privacyPart3' | translate }}
          <u>{{ 'components.login.labels.privacyPart4' | translate }}</u>
        </app-link>
      </ng-template>

      <ng-template #mobileAppLinks>
        <app-mobile-app-download-links
          *ngIf="!env.isMobilePlatform"
          class="mobile-app-download-links"
          [appStoreLink]="appConfig?.appStoreLink"
          [googlePlayLink]="appConfig?.googlePlayLink"
          [ruStoreLink]="appConfig?.ruStoreLink"
        ></app-mobile-app-download-links>
      </ng-template>

      <div *ngIf="appConfig?.loginScreenDescription" class="description">
        {{ appConfig?.loginScreenDescription }}
      </div>

      <div class="version">{{ APP_VERSION }}</div>
    </div>
  </div>
</tui-scrollbar>

<ng-template [tuiSheetOptions]="appSheetOptions" [(tuiSheet)]="appSheetOpen">
  <app-download-links [options]="downloadLinksOptions"></app-download-links>
</ng-template>

<tui-sheets-host ngProjectAs="tuiOverContent"></tui-sheets-host>

<ng-template #notificationLoginTmp>
  <tui-notification *ngIf="!appConfig || appConfig.allowUserRegistrationForm" [appearance]="'warning'" [size]="'m'">
    {{ 'components.login.labels.notificationLogin' | translate }}
  </tui-notification>
</ng-template>
